let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bjmre"), load("11DLa"), load("bcQs2"), load("cft22"), load("iouLY"), load("4sOIV")]).then(() => parcelRequire('73LWR'));